import * as yup from 'yup';

export const getCompaniesDomainsFilterSchema = yup.object().shape({
  domains: yup.array().of(yup.string()),
});
